import { render } from "./PayrollDetail.vue?vue&type=template&id=14288e78"
import script from "./PayrollDetail.vue?vue&type=script&lang=js"
export * from "./PayrollDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__